module.exports = __webpack_public_path__ + "img/newyear.e3683fb0.png";